
import Vue from "vue";
export default Vue.extend({
	props: {
		clickable: Boolean,
		center: Boolean,
		notActive: Boolean
	},
	computed: {
		classes():any{
			return {
				center: this.center,
				"not-active": this.notActive
			};
		}
	},
	methods: {
		onClick(event:Event){
			this.$emit("click", event);
		}
	}
});
